export default __webpack_public_path__ + "static/media/lock.c73245e9.svg";